import { render, staticRenderFns } from "./shedDetails.vue?vue&type=template&id=48fe726e&scoped=true&"
import script from "./shedDetails.vue?vue&type=script&lang=js&"
export * from "./shedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe726e",
  null
  
)

export default component.exports